const PROJECT_ID = '4507622227574784';

export {PROJECT_ID};
